// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datepicker-widget{width:135px;margin:2px 5px 5px 5px}`, "",{"version":3,"sources":["webpack://./src/components/AppNavigation/AppNavigationHeader/AppNavigationHeaderDatePicker.vue"],"names":[],"mappings":"AACA,mBACC,WAAA,CACG,sBAAA","sourcesContent":[".datepicker-widget{width:135px;margin:2px 5px 5px 5px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
